<template>  
    <div class="remind_list">
        <div class="remind_list-header">
            <HomePatientBase
                v-if="info.name"
				type="gray"
				toggleArchiveType="button"
				actionClass="patient_button_style"
				:avatar="info.avatar"
				:patient-name="info.name"
				:desc="`${ $status.gender[info.gender] } ${ info.age }岁`"
                :showRight="false"
			/>
        </div>
        <van-popup :overlay="false" round :value="true" position="bottom" class="no_data_style" >
            <div class="remind_item van-ellipsis" v-for="item in info.list" :key="item.id" @click="goDetail(item)">
                <div class="remind_item-top">
                    <div class="status" :style="`color:${reminderStatus[item.reminderStatus]}`">{{item.reminderStatusName}}</div>
                    <div class="time">{{$moment(item.reminderDate).format('YYYY-MM-DD')}}<van-icon name="arrow" /></div>
                </div>
                <div class="remind_item-bottom van-ellipsis">
                    <span>{{item.reminderTime}}</span>
                    {{item.reminderContent}}
                </div>
            </div>
            <van-empty v-if="info.list.length===0" >
                <template #image>
                    <img src="../../assets/img/empty_4.png" />
                </template>
                <template #description>
                    <div class="empty_description">暂无数据</div>
                </template>
            </van-empty>
        </van-popup>
    </div>
</template>
<script>
import HomePatientBase from '../main/components/patient-base.vue'
export default{
    components:{HomePatientBase},
    data(){
        return{
            info:{
                list:[]
            },
            reminderStatus:{
                2:'#15C5CE',
                1:'#FFAD0D',
                3:'#FA5151'
            }
        }
    },
    computed: {
        patientId(){
            return this.$route.params.id
        },
        type(){
            return this.$route.params.type
        }
    },
    created(){
        this.getDataList()
    },
    methods:{
        getDataList(){
            this.$api.patient.getPatientMedicationRecord({patientId:this.patientId}).then(({code,data})=>{
                if (!code) {
					this.info =data
                }
            })
        },
        goDetail(item){
            let obj = JSON.parse(JSON.stringify(this.info))
            delete obj.list
            this.$router.push({
                path:`/takeMedicine/detail/${item.id}`,
                query:{
                    info:JSON.stringify(obj),
                    type:this.type
                }
            })
        }
    }
}
</script>
<style lang="less" scoped>
.remind_list{
   background-color: #f5f6f7; 
   &-header{
    padding:12px 32px 40px 32px ;
   }
   .remind_item{
        background-color: #F5F6F7;
        border-radius: 16px;
        padding: 32px 28px;
        margin: 0 32px 20px 32px;
        &-top{
            display: flex;
            justify-content: space-between;
            font-size: 26px;
            color: #8F959E;
            align-items: center;
            margin-bottom: 28px;
            .status{
                font-size: 32px;
                font-weight: bold;
            }
        }
        &-bottom{
            font-size: 28px;
            color: @gray-9;
            span{
                display: inline-block;
                width: 90px;
                margin-right: 16px;
                font-size: 32px;
                color: #1F2329;
                font-weight: bold;
            }
        }
   }
}
.no_data_style{
    height: calc(100vh - 228px);
    padding: 40px 0;
}
.empty_description{
    color: #000000;
    font-size: 40px;
    line-height: 48px;
    font-weight: 600;
    margin-top: 60px;
    text-align: center;
}
</style>